import api from './axiosConfig';
import { handleApiError } from './errorHandler';

/**
 * Get reorder alerts for stock items
 * @param {Object} filters - Filter parameters
 * @param {string} filters.severity - Filter by severity ('critical', 'warning', 'watch')
 * @param {number} filters.category - Filter by category ID
 * @param {number} filters.manufacturer - Filter by manufacturer ID
 * @param {number} filters.stock_item_id - Get alert for specific stock item
 * @returns {Promise} API response with reorder alerts
 */
export const getReorderAlerts = async (filters = {}) => {
    try {
        const params = {};

        if (filters.severity) {
            params.severity = filters.severity;
        }
        if (filters.category) {
            params.category = filters.category;
        }
        if (filters.manufacturer) {
            params.manufacturer = filters.manufacturer;
        }
        if (filters.stock_item_id) {
            params.stock_item_id = filters.stock_item_id;
        }

        const { data } = await api.get('/api/analytics/reorder-alerts/', { params });
        return data;
    } catch (error) {
        handleApiError(error, 'Get reorder alerts error:');
        throw error;
    }
};

export const reorderAlertAPI = {
    getReorderAlerts,
};
